/* eslint-disable react/display-name */
import React, { lazy, memo } from "react";
const RFIDLogsPage = lazy(() => import("./pages/rfid-logs"));
const RFIDPage = lazy(() => import("./pages/rfid/index"));
const RFIDBagPage = lazy(() => import("./pages/rfid-bag/index"));
const RFIDScannerLogsPage = lazy(() => import("./pages/rfid-scanner-logs"));

const RfidRoutes = [
  { path: "logs", element: <RFIDLogsPage /> },
  { path: "manage", element: <RFIDPage /> },
  { path: "bag", element: <RFIDBagPage /> },
  { path: "rfid-scanner-log", element: <RFIDScannerLogsPage /> },
];
export default RfidRoutes;
